// Static snapshot of live Google reviews (pulled 2026-09-14).
// Baked into the site so pages render instantly with no live API lookups.
// Refresh occasionally by re-pulling from the stored Google reviews.

export const GOOGLE_RATING = 5.0;
export const GOOGLE_REVIEW_COUNT = 125;

export type SnapshotReview = { name: string; when: string; text: string };

// Newest live reviews not already in the curated home-page lists.
export const snapshotReviews: SnapshotReview[] = [
  {
    name: "Cecily Bailey",
    when: "2 weeks ago",
    text: "Couldn't be better. Here and done in one hour! They have great equipment and great service. Very cooperative about scheduling and great attention to requests and detail. We will use this company again.",
  },
  {
    name: "Kerstin Ehman",
    when: "2 months ago",
    text: "We recently had our patio pavers cleaned and resanded by Luis and his company, and the results were phenomenal! He transformed our patio and it looks brand new again. Everything was left spotless. We couldn't be happier with how everything turned out!",
  },
  {
    name: "Cherie Cole",
    when: "2 months ago",
    text: "They did an excellent job cleaning our gutters. They really hadn't been done in a while but they were great. Their price was so reasonable. I recommend them highly.",
  },
  {
    name: "Melissa Allard",
    when: "2 months ago",
    text: "Luis and team were very professional and did a fantastic job. I am very happy with their service and would recommend them to anyone in the Capital District looking for a cleaning.",
  },
  {
    name: "Eric Mohamed",
    when: "2 months ago",
    text: "Luis and his staff were amazing and very friendly. As soon as I approved the estimate, they were here the next morning ready to work. Did an amazing job on my roof and house. Great company and great work. Definitely recommend them.",
  },
  {
    name: "Kim Willey",
    when: "4 months ago",
    text: "Staff was courteous and knowledgeable. Care was taken with the newer vinyl siding and time was taken with the deck which is 12 yrs old and unfinished. Very satisfied with the result.",
  },
];
